const PLACE_LABELS: Record<string, string> = {
  airport: 'Airport',
  'amusement-park': 'Amusement park',
  aquarium: 'Aquarium',
  bakery: 'Bakery',
  'bowling-alley': 'Bowling',
  campsite: 'Campground',
  car: 'Car dealer',
  'car-rental': 'Car rental',
  'car-repair': 'Car repair',
  casino: 'Casino',
  cinema: 'Cinema',
  'fast-food': 'Fast food',
  'fitness-centre': 'Fitness',
  fuel: 'Gas station',
  furniture: 'Furniture',
  golf: 'Golf',
  grocery: 'Grocery',
  harbor: 'Marina',
  hardware: 'Hardware',
  hospital: 'Hospital',
  lodging: 'Hotel',
  'alcohol-shop': 'Liquor store',
  parking: 'Parking',
  'parking-garage': 'Parking',
  'parking-paid': 'Parking',
  restaurant: 'Restaurant',
  'restaurant-noodle': 'Restaurant',
  'restaurant-pizza': 'Restaurant',
  'restaurant-seafood': 'Restaurant',
  shop: 'Shop',
  stadium: 'Stadium',
  terminal: 'Train station',
  bus: 'Bus stop',
  rail: 'Train station',
  'rail-metro': 'Metro',
  'rail-light': 'Light rail',
  ferry: 'Ferry',
  zoo: 'Zoo',
};

/** Readable type for a basemap icon. An unknown name is still a label. */
export function placeTypeLabel(maki: string): string {
  const known = PLACE_LABELS[maki];
  if (known) return known;
  if (!maki) return 'Place';
  return maki
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/** Day circle fills from Standard's poi-label. The glyph on that circle is white. */
const FOOD = 'hsl(30, 100%, 60%)';
const EDUCATION = 'hsl(30, 50%, 50%)';
const MEDICAL = 'hsl(0, 94%, 72%)';
const SPORT = 'hsl(190, 75%, 50%)';
const STORE = 'hsl(210, 75%, 65%)';
const ARTS = 'hsl(320, 85%, 72%)';
const SERVICES = 'hsl(250, 75%, 72%)';
const PARK = 'hsl(110, 70%, 40%)';
const OTHER = 'hsl(200, 20%, 55%)';
/** Day circle on the transit-label layer. */
const TRANSIT = 'hsl(225, 60%, 58%)';
const GLYPH = 'hsl(0, 0%, 100%)';

/** A light wash of the map color, with the icon and label in a darker shade of it. */
export function placeChipColors(
  maki: string,
  placeClass: string,
): { background: string; foreground: string } {
  return pastel(categoryColor(maki, placeClass));
}

/** The map marker: category-colored circle, white glyph. */
export function placeMarkerColors(
  maki: string,
  placeClass: string,
): { background: string; foreground: string } {
  return { background: categoryColor(maki, placeClass), foreground: GLYPH };
}

function pastel(color: string): { background: string; foreground: string } {
  const parts = color.match(/hsl\((\d+), (\d+)%, (\d+)%\)/);
  if (!parts) return { background: color, foreground: '#021715' };
  const hue = parts[1];
  const saturation = Number(parts[2]);
  const wash = Math.round(saturation * 0.42);
  const ink = Math.max(35, Math.round(saturation * 0.7));
  return {
    background: `hsl(${hue}, ${wash}%, 92%)`,
    foreground: `hsl(${hue}, ${ink}%, 30%)`,
  };
}

function categoryColor(maki: string, category: string): string {
  if (category === 'transit_stop') return TRANSIT;
  if (category === 'food_and_drink') return FOOD;
  if (category === 'education') return EDUCATION;
  if (category === 'medical') return MEDICAL;
  if (category === 'sport_and_leisure') return SPORT;
  if (category === 'store_like' || category === 'food_and_drink_stores') return STORE;
  if (
    maki === 'zoo' ||
    maki === 'museum' ||
    maki === 'communications-tower' ||
    category === 'arts_and_entertainment' ||
    category === 'historic' ||
    category === 'landmark'
  ) {
    return ARTS;
  }
  if (
    maki === 'car-repair' ||
    category === 'commercial_services' ||
    category === 'motorist' ||
    category === 'lodging'
  ) {
    return SERVICES;
  }
  if (maki === 'picnic-site' || category === 'park_like') return PARK;
  return OTHER;
}
